import styled from 'styled-components'
import { Spinner } from '@geist-ui/react'

export const SmallSpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
`

export const SmallSpinner = styled(Spinner)`
  min-width: 32px;
  min-height: 32px;
`
